import BillingModel from "../../../../types/billing-model";
import BillingStatus from "../../../../types/billing-status";
import TaxiCorporationBillingType from "../../../../types/taxi-corporation-billing-type";

export enum TaxiCorporationOrderBillingsDownloadParamsOrder {
  DATE_ASC = "DATE_ASC",
  DATE_DESC = "DATE_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  BILLING_MODEL_ASC = "BILLING_MODEL_ASC",
  BILLING_MODEL_DESC = "BILLING_MODEL_DESC",
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
  DISTANCE_RATE_ASC = "DISTANCE_RATE_ASC",
  DISTANCE_RATE_DESC = "DISTANCE_RATE_DESC",
  DISTANCE_AMOUNT_ASC = "DISTANCE_AMOUNT_ASC",
  DISTANCE_AMOUNT_DESC = "DISTANCE_AMOUNT_DESC",
  HALTING_AMOUNT_ASC = "HALTING_AMOUNT_ASC",
  HALTING_AMOUNT_DESC = "HALTING_AMOUNT_DESC",
  HIGHWAY_CHARGE_ASC = "HIGHWAY_CHARGE_ASC",
  HIGHWAY_CHARGE_DESC = "HIGHWAY_CHARGE_DESC",
  TOTAL_AMOUNT_ASC = "TOTAL_AMOUNT_ASC",
  TOTAL_AMOUNT_DESC = "TOTAL_AMOUNT_DESC",
}

type TaxiCorporationOrderBillingsDownloadParams = {
  taxiCorporationUuid: string;
  order?: TaxiCorporationOrderBillingsDownloadParamsOrder;
  humanId?: number;
  planEntryHumanIds?: number;
  dateSince?: string;
  dateTo?: string;
  cargoCompany?: string;
  excludeCargoCompany?: string;
  passenger?: string;
  status?: BillingStatus;
  billingModel?: BillingModel;
  billingType?: TaxiCorporationBillingType;
  responsibleTaxi?: string;
};

export default TaxiCorporationOrderBillingsDownloadParams;
